export function addService(service, index) {
    return {
        type: 'ADD_SERVICE',
        service, index
    }
}

export function selectService(service) {
    return {
        type: 'SELECT_SERVICE',
        service
    }
}

export function clearSelectedService(service) {
    return {
        type: 'CLEAR_SERVICE',
        service
    }
}

export function addSlide(slide, index) {
    return {
        type: 'ADD_SLIDE',
        slide, index
    }
}
export function clearSlides(slides) {
    return {
        type: 'CLEAR_SLIDES',
        slides
    }
}
export function addGalleryImage(galleryImage, index) {
    return {
        type: 'ADD_GALLERY_IMAGE',
        galleryImage, index
    }
}
export function clearGalleryImages(galleryImages) {
    return {
        type: 'CLEAR_GALLERY_IMAGES',
        galleryImages
    }
}

export function setContent(content) {
    return {
        type: 'SET_CONTENT',
        content
    }
}


// WEBPACK FOOTER //
// ./src/actions/actionCreators.js